import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from 'types/auth/types';

type State = {
  token: string | null;
  refreshToken: string | null;
  user: User | null;
};

const initialState: State = { token: null, refreshToken: null, user: null };

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthTokens(state: State, action: PayloadAction<{ token?: string; refreshToken?: string }>) {
      if (action.payload.refreshToken) {
        state.refreshToken = action.payload.refreshToken;
      }
      if (action.payload.token) {
        state.token = action.payload.token;
      }
    },
    setUser(state: State, action: PayloadAction<User>) {
      state.user = action.payload;
    },
    logout(state: State) {
      state.user = null;
      state.refreshToken = null;
      state.token = null;
    },
  },
});

export default authSlice;
